/* Convert only explicitly labelled facts; retain unstructured content verbatim. */
document.querySelectorAll('[data-emberose-details]').forEach((details) => {
  details.querySelectorAll('ul').forEach((list) => {
    const items=Array.from(list.children);
    const labelFor=(item)=>{
      if(item.firstElementChild?.tagName==='STRONG')return {element:item.firstElementChild,text:item.firstElementChild.textContent.trim().replace(/:$/,'')};
      const first=Array.from(item.childNodes).find(n=>n.nodeType!==Node.TEXT_NODE||n.textContent.trim());
      if(first?.nodeType!==Node.TEXT_NODE)return null;
      const match=first.textContent.match(/^\s*([^:\n]{1,180}):\s*/);
      return match?{node:first,text:match[1].trim(),length:match[0].length}:null;
    };
    if (!items.length || items.some((item)=>item.tagName!=='LI')) return;
    const grid=document.createElement('dl');grid.className='emberose-details-grid';
    let notes=null;
    items.forEach((item)=>{
      const label=labelFor(item);
      if(!label){
        if(!notes){const term=document.createElement('dt');term.textContent='Notes';notes=document.createElement('dd');grid.append(term,notes);}
        const paragraph=document.createElement('p');while(item.firstChild)paragraph.append(item.firstChild);notes.append(paragraph);return;
      }
      notes=null;
      const term=document.createElement('dt');term.textContent=label.text;
      const value=document.createElement('dd');
      if(label.element)label.element.remove();else label.node.textContent=label.node.textContent.slice(label.length);
      while(item.firstChild)value.append(item.firstChild);
      // Paragraph-length labels need the full reading width.
      if(label.text.length>55){
        term.classList.add('emberose-details-grid__wide-label');
        value.classList.add('emberose-details-grid__wide-value');
      }
      grid.append(term,value);
    });
    list.replaceWith(grid);
  });
});

document.querySelectorAll('[data-emberose-layout] [data-product-gallery]').forEach((gallery)=>{
  const dialog=gallery.querySelector('[data-gallery-lightbox]');
  const image=gallery.querySelector('[data-gallery-lightbox-image]');
  const viewport=gallery.querySelector('[data-gallery-viewport]');
  const canvas=gallery.querySelector('[data-gallery-canvas]');
  if(!dialog||!image||!viewport||!canvas)return;
  const fit=gallery.querySelector('[data-gallery-fit]'),plus=gallery.querySelector('[data-gallery-zoom-in]'),minus=gallery.querySelector('[data-gallery-zoom-out]'),level=gallery.querySelector('[data-gallery-zoom-level]'),original=gallery.querySelector('[data-gallery-original]');
  let zoom=1,drag=null;
  const render=(reset=false)=>{
    if(!dialog.open||!image.naturalWidth||!viewport.clientWidth)return;
    const x=(viewport.scrollLeft+viewport.clientWidth/2)/Math.max(canvas.offsetWidth,1),y=(viewport.scrollTop+viewport.clientHeight/2)/Math.max(canvas.offsetHeight,1);
    const scale=Math.min(viewport.clientWidth/image.naturalWidth,viewport.clientHeight/image.naturalHeight,1)*zoom;
    const width=Math.round(image.naturalWidth*scale),height=Math.round(image.naturalHeight*scale);
    image.style.width=`${width}px`;image.style.height=`${height}px`;
    canvas.style.width=`${Math.max(width,viewport.clientWidth)}px`;canvas.style.height=`${Math.max(height,viewport.clientHeight)}px`;
    viewport.scrollLeft=reset?0:x*canvas.offsetWidth-viewport.clientWidth/2;viewport.scrollTop=reset?0:y*canvas.offsetHeight-viewport.clientHeight/2;
    level.textContent=`${Math.round(zoom*100)}%`;minus.disabled=zoom<=1;plus.disabled=zoom>=4;original.href=image.src;
  };
  const setZoom=(n)=>{zoom=Math.min(4,Math.max(1,n));render(zoom===1);};
  plus.addEventListener('click',()=>setZoom(zoom+.5));minus.addEventListener('click',()=>setZoom(zoom-.5));fit.addEventListener('click',()=>setZoom(1));
  image.addEventListener('load',()=>render(true));
  gallery.querySelectorAll('[data-gallery-open-image],[data-gallery-previous],[data-gallery-next]').forEach((button)=>button.addEventListener('click',()=>setZoom(1)));
  viewport.addEventListener('keydown',(e)=>{
    const moves={ArrowLeft:[-80,0],ArrowRight:[80,0],ArrowUp:[0,-80],ArrowDown:[0,80]};
    if(moves[e.key]){e.preventDefault();viewport.scrollBy(...moves[e.key]);}
    else if(e.key==='Home'){e.preventDefault();viewport.scrollTo(0,0);}
    else if(e.key==='End'){e.preventDefault();viewport.scrollTo(viewport.scrollWidth,viewport.scrollHeight);}
    else if(e.key==='+'||e.key==='='){e.preventDefault();setZoom(zoom+.5);}
    else if(e.key==='-'){e.preventDefault();setZoom(zoom-.5);}
    else if(e.key==='0'){e.preventDefault();setZoom(1);}
  });
  viewport.addEventListener('pointerdown',(e)=>{if(zoom<=1||e.pointerType==='touch'||e.button!==0)return;drag={x:e.clientX,y:e.clientY,left:viewport.scrollLeft,top:viewport.scrollTop};viewport.setPointerCapture(e.pointerId);viewport.focus();e.preventDefault();});
  viewport.addEventListener('pointermove',(e)=>{if(drag){viewport.scrollLeft=drag.left+drag.x-e.clientX;viewport.scrollTop=drag.top+drag.y-e.clientY;}});
  ['pointerup','pointercancel','lostpointercapture'].forEach(type=>viewport.addEventListener(type,()=>{drag=null;}));
  dialog.addEventListener('close',()=>{drag=null;});new ResizeObserver(()=>render(zoom===1)).observe(viewport);
});
